const state = {
    token: ''
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
}

const actions = {
    setToken({ commit }, data) {
        commit('SET_TOKEN', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}